import './styles.scss';

import {PropsWithChildren} from 'react';

interface AppDefinitionProps extends PropsWithChildren {
    label: string;
}

export const AppDefinition = ({label, children}: AppDefinitionProps) => {
    return (
        <div className='app-definition'>
            <div className='app-definition__label'>{label}</div>
            <div className='app-definition__value'>{children}</div>
        </div>
    );
};
